module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('list-view', {
    staticClass: "component-type-selector"
  }, _vm._l((_vm.componentTypes), function(type) {
    return (_vm.isComponentTypeVisible(type.id)) ? _c('div', {
      staticClass: "component-type-button",
      attrs: {
        "disabled": !_vm.isComponentTypeEnabled(type.id),
        "selected": _vm.isComponentTypeSelected(type.id)
      },
      on: {
        "click": function($event) {
          _vm.componentTypeSelected(type.id)
        }
      }
    }, [_c('i', {
      class: _vm.iconClass(type.id)
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(type.title))])]) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13a45c6d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-type-selector.vue
// module id = 192
// module chunks = 5